import React from "react";
import "./Secondhero.scss";

import kiriatas from "../../Media/Foto_About/Kiri Atas.webp";
import kiribawah from "../../Media/Foto_About/Kiri Bawah.webp";
import kananatas from "../../Media/Foto_About/Kanan Atas.webp";
import kananbawah from "../../Media/Foto_About/Kanan Bawah.webp";

const SecondHero = () => {
  return (
    <div className="secondherocontainers" id="about">
      <div className="secondmiddle">
        <div className="leftcontent">
          <div className="content-judulabout">
            <h1>Summarecon Serpong</h1>
            <h2>Better Living, Better Future </h2>
          </div>
          <div className="contentdescription">
            Summarecon Serpong adalah kawasan hunian terpadu di Tangerang yang
            dikembangkan oleh Summarecon Agung, menghadirkan perumahan modern,
            area komersial, dan fasilitas lengkap seperti sekolah, rumah sakit,
            pusat perbelanjaan, dan akses tol langsung. Terletak strategis di
            jantung BSD dan Gading Serpong, Summarecon Serpong menjadi pilihan
            ideal untuk keluarga dan investor yang mencari properti berkualitas
            tinggi dengan nilai investasi yang terus berkembang. Cari rumah di
            Summarecon Serpong sekarang dan temukan kenyamanan hidup di
            lingkungan hijau dan berkembang pesat.
          </div>
        </div>
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
